import { marked } from 'marked';
import { Source } from '../types/interfaces';

function sequenceSources(answer: string, sources: Source[]) {
  const sourceRegex = /{{source-\d+}}/g;
  const matches = answer.match(sourceRegex);
  if (!matches) return { newAnswer: answer, usedSources: [] };

  const uniqueSources = [...new Set(matches)];
  const sourceMap = new Map();
  uniqueSources.forEach((source, index) => {
    sourceMap.set(source, `{{source-${index + 1}}}`);
  });

  let newAnswer = answer;
  sourceMap.forEach((newSource, oldSource) => {
    newAnswer = newAnswer.replace(new RegExp(oldSource, 'g'), newSource);
  });

  const usedSourceIds = Array.from(sourceMap.keys()).map(source => {
    const match = source.match(/{{source-(\d+)}}/);
    return match ? parseInt(match[1]) : null;
  }).filter(id => id !== null);

  const usedSources = sources.filter(source => usedSourceIds.includes(source.id))
    .map((source, index) => ({ ...source, id: index + 1 }));

  return { newAnswer, usedSources };
}

function cleanSourceStrings(answer: string) : string {
  // change ({{source-1}}) ... ({{source-n}}) to just {{source-1}} ... {{source-n}}
  answer = answer.replaceAll('({', '{');
  answer = answer.replaceAll('})', '}');
  return answer;
}

function getSources(answer: string) : string[] {
  const regexForSources = /{?{sources?-?\d+}?}/g;
  const sourceStringsInText = answer.match(regexForSources);

  // remove duplicate values from sources
  const uniqueSourcesStringInText = [...new Set(sourceStringsInText)];
  return uniqueSourcesStringInText;
}

function replaceSourcesWithSuffixIDs(answer: string) : string {
  const sources = getSources(answer);
  for (let i = 0; i < sources.length; i++) {
    // (`look for source ${sources[i]}`)
    // get id from source text ie [source-1] becomes 1
    const matchResult = sources[i].match(/\d+/);
    const id = matchResult ? matchResult[0] : '';

    // hacky, but first do a replace where sources[i] is followed by a space
    answer = answer.replaceAll(' ' + sources[i], `<span class="reference">(${id})</span>`);
    answer = answer.replaceAll(sources[i], `<span class="reference">(${id})</span>`);
  }
  return answer;
}

function allHrefsTargetNew(html: string): string {
  return html.replaceAll('<a href=', '<a target="_blank" href=');
}

export function renderAnswer(answer: string, sources: Source[]) {
  const cleanAnswer = cleanSourceStrings(answer);
  const { newAnswer } = sequenceSources(cleanAnswer, sources);
  const answerWithSources = replaceSourcesWithSuffixIDs(newAnswer ?? '');
  const markup = marked(answerWithSources) as string;
  const allHrefsTargetNewMarkup = allHrefsTargetNew(markup);
  return allHrefsTargetNewMarkup;
}

export function getUsedSourceArray(answer: string, sources: Source[]) {
  const cleanAnswer = cleanSourceStrings(answer);
  const { usedSources } = sequenceSources(cleanAnswer, sources);
  return usedSources;
}
